import Plan from './Plan.jsx'

export default Plan
